import {apiUrl} from "../utils/constants";
import {GET} from "./api.service.wrapper";


export const GetBlogs = async (args) => {
    const response = await GET(apiUrl.blogs, args);
    return response;
}